import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class ActionsTableCell extends Component {
    render() {
        const { OnDeactivate } = this.props;
        const { OnActivate } = this.props;
        const customer = this.props.dataItem;
        return (
            <td className="action-buttons">
                {customer.IsActive === true && (window.USER_PERMISSION.indexOf('EDT_CUST') > -1 ) && (
                    <Link
                        to={{
                            pathname: '/admin/customer/edit',
                            customer: customer,
                            action: 'edit'
                        }}
                    >
                        <div className="rounded-link">
                            <span className="k-icon k-i-edit" title="Edit" />
                        </div>
                    </Link>
                 )}
                {customer.IsActive === true  && (window.USER_PERMISSION.indexOf('EDT_CUST') > -1 ) && (
                    <Link
                        to={this.props}
                        onClick={(e) => { e.preventDefault(); OnDeactivate(this.props.dataItem.id); }}
                    >
                        <div className="rounded-link">

                            <span className="k-icon k-i-unsort" title="Deactivate" />
                        </div>
                    </Link>
                )}
                {customer.IsActive === false  && (window.USER_PERMISSION.indexOf('EDT_CUST') > -1 ) && (
                    <Link
                        to={this.props}
                        onClick={(e) => { e.preventDefault(); OnActivate(this.props.dataItem.id); }}
                    >
                        <div className="rounded-link">

                            <span className="k-icon k-i-check" title="Activate" />
                        </div>
                    </Link>
                )}
            </td>
        );
    }
}

export default ActionsTableCell;
